// removed by extract-text-webpack-plugin
module.exports = {"eligibleContainer":"eligibleContainer__1Zv1G","inputContainer":"inputContainer__HiTlv","inputBox":"inputBox__1FJCO","submitButton":"submitButton__2cjex","aboutInputText":"aboutInputText__8h5wu","spinnerWrapper":"spinnerWrapper__3XTbC"};


//////////////////
// WEBPACK FOOTER
// ./components/buyWithInstacredLanding/eligibilityPanel/style.css
// module id = xrAC
// module chunks = 323